export default {
  tabs: [{
    name: 'NcPricingList',
    path: '/nc/ncPricingList',
    component: () => import('./src/ncPricing'),
    meta: {
      title: 'NC定价',
      isMenu: true
    }
  },
  {
    name: 'NcPricingDetail',
    path: '/nc/ncPricingDetail/:ncOrderId',
    component: () => import('./src/ncPricing/details.vue'),
    meta: {
      title: '零售定价',
      // keepAlive: false // 考虑后期可能会有跳第三方系统的可能，不采用keepAlive缓存了
    }
  },
  {
    name: 'NcAuditList',
    path: '/nc/ncAuditList',
    component: () => import('./src/ncAudit'),
    meta: {
      title: '收车审核',
      isMenu: true
    }
  },
  {
    name: 'NcAuditListV2',
    path: '/nc/ncAuditListV2',
    component: () => import('./src/ncAudit'),
    meta: {
      title: '收车审核',
      isMenu: true
    }
  },
  {
    name: 'NcAuditDetail',
    path: '/nc/ncAuditDetail/:ncOrderId/:auditV2/:moneyType',
    component: () => import('./src/ncAudit/details.vue'),
    meta: {
      title: '收车审核',
      isMenu: true
    }
  },
  {
    name: 'NcAuditPictureDetail',
    path: '/nc/ncAuditPictureDetail/:ncOrderId',
    component: () => import('./src/ncAudit/pictureDetail.vue'),
    meta: {
      title: '手续图片',
      isMenu: true
    }
  }]
}
